var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFeatureDefault = function SvgIconFeatureDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    fill: "none",
    viewBox: "0 0 52 52"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#131212",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.484,
    d: "M1 15.467V3.885l7.624 7.621 5.79 5.79M14.414 28.88l-5.79 5.793L1 27.05V15.467l7.624 7.623z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#131212",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.484,
    d: "m8.621 23.09 5.792 5.79 14.481-14.481-5.79-5.792L11.371 20.34M1 38.638v-.002M1 38.637v12.361h12.36l-4.736-4.74zM15.465 50.998l7.637-7.635 5.792-5.792v-.002l-5.79-5.79-11.733 11.73M43.375 34.673l-5.793-5.79-14.48 14.48 5.792 5.79zM51 42.295v8.703h-2.883L37.586 40.463l5.79-5.79zM28.894 49.179l-1.82 1.819H15.493"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#131212",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.484,
    d: "m43.377 46.283-4.713 4.715h9.454M39.719 26.746l3.66-3.656L51 30.712v11.583"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#131212",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.484,
    d: "M51 19.13v11.582l-7.622-7.622-5.792-5.794 5.79-5.792zM37.585 17.296l-8.693 8.688-5.79-5.79"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#131212",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.484,
    d: "M51 19.13V1h-8.7l-4.714 4.711 5.79 5.793zM12.326 3.626l2.088 2.087.002.002-5.792 5.79L1 3.886V1h8.701M9.703 1h9.43l-4.715 4.715M8.625 34.673l5.792 5.792M28.894 25.984l-5.788 5.794M30.717 1l-7.611 7.608M42.297 1H30.715M19.133 1h11.584M1 27.051v11.587M38.661 50.998H27.074M31.79 11.506l5.796-5.795"
  })));
};
export default SvgIconFeatureDefault;